import { h, Component } from 'preact';
import { sortObjectByOrder, joinClasses, accessNested } from 'utils/utils';
import * as webp from 'utils/bolt/webp';
import Store from 'store/store';
import s from 'components/bolt/uarHeader/uarHeader.sss';

export default class UarHeader extends Component {

	needsOpaque() {
		const activePage = Store.get().activePage;
		const pagesNeeded = ['boltShowtimes', 'boltHomeEnt', 'boltVideos'];
		if (pagesNeeded.includes(activePage)) {
			return true;
		}

		if (Store.get()?.appData?.pages[activePage]?.needsOpaqueUarHeader) {
			return true;
		}

		return false;
	}

	getFallbackFormat() {
		return accessNested(Store.get(), 'appData.header.alternativeImageFormat', 'png');
	}

	render({ data }) {
		const { logo } = data;
		const pages = data?.nav || {};
		const needsOpaque = this.needsOpaque();
		const tt = logo.src;
		const fallbackFormat = this.getFallbackFormat();

		return (
			<header class={joinClasses(s.wrapper, needsOpaque && s.opaque)}>
				<a class={s.logo} href="https://www.unitedartistsreleasing.com">
					<webp.Picture
						src={tt}
						alt={logo.altText}
						fallbackFormat={fallbackFormat}
					/>
				</a>
				<nav class={s.nav}>
					{sortObjectByOrder(pages).map(element => {
						const target = element.sameWindow ? '_self' : '_blank';
						if (element.path.match(/^http/)) {
							return (
								<a href={element.path} target={target} class={s.link}>
									{element.name}
								</a>
							);
						}
						return (
							<button
								class={s.link}
								onClick={() => Store.emit('SET_ACTIVE_PAGE', element.path)}
							>
								{element.name}
							</button>
						);
					})}
				</nav>
			</header>
		);
	}
}
